export default "__VITE_ASSET__CWTLrrEi__"